import { render, staticRenderFns } from "./ExpandableTextArea.vue?vue&type=template&id=0c934514"
import script from "./ExpandableTextArea.vue?vue&type=script&lang=js"
export * from "./ExpandableTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports